import * as Styled from "./style";
import { AppealForPremiumPlan } from "~/components/blocks/layout/global-navi/common/user-menu/appeal-for-premium-plan";
import { useServicePlan } from "~/components/blocks/layout/global-navi/common/user-menu/hooks/use-service-plan";
import { MenuList } from "~/components/blocks/layout/global-navi/common/user-menu/menu-list";
import { ServicePlanForPremium } from "~/components/blocks/layout/global-navi/common/user-menu/service-plan-for-premium";
import { UserPoint } from "~/components/blocks/layout/global-navi/common/user-menu/user-point";
import { EXTERNAL_PATHS } from "~/const/paths";
import { useMatchMedia } from "~/hooks/use-match-media";
import { G_ServicePlan } from "~/lib/graphql";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { useAuth } from "~/provider/auth";

export type UserMenusProps = {
  onHideUserMenu: () => void;
};

export const UserMenus = ({ onHideUserMenu }: UserMenusProps) => {
  const { isLoggedIn, servicePlan } = useAuth();
  const { userMenuType } = useServicePlan({
    isLoggedIn,
    servicePlan,
  });
  const { isPcSize } = useMatchMedia();
  const isPremium = servicePlan === G_ServicePlan.Premium;

  return (
    <Styled.DivContainer>
      <UserPoint onHideUserMenu={onHideUserMenu} />
      {isPremium ? (
        <>
          <a
            href={EXTERNAL_PATHS.BENEFIT}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              sendTrackingClickCommon({
                clickEventName: "dmmtv_premiumsite_sp",
                viaInfo: "mymenu",
              });
            }}
          >
            {isPcSize ? (
              <Styled.ImgDesktopPremiumBanner
                src="https://imgsrc.dmm.com/dig/dmmtv/etc/navi/premium_benefit.png"
                alt="プレミアムバナー"
              />
            ) : (
              <Styled.ImgMobilePremiumBanner
                src="https://imgsrc.dmm.com/dig/dmmtv/etc/navi/premium_benefit_sp.png"
                alt="プレミアムバナー"
              />
            )}
          </a>
          <ServicePlanForPremium onHideUserMenu={onHideUserMenu} />
        </>
      ) : (
        <AppealForPremiumPlan onHideUserMenu={onHideUserMenu} />
      )}
      <MenuList userMenuType={userMenuType} onHideUserMenu={onHideUserMenu} />
    </Styled.DivContainer>
  );
};
